module.exports = __webpack_public_path__ + "img/coupon-item-invalid-bg.61ec3120.png";